/**
 * @file Default date format options
 */

/**
 * @typedef {Object} DateFormatOptions
 * @property {string} [year]
 * @property {string} [month]
 * @property {string} [day]
 * @property {string} [hour]
 * @property {string} [minute]
 * @property {string} [second]
 * @property {string} [timeZoneName]
 * @property {string} [timeZone]
 */

/**
 * @enum {DateFormatOptions}
 * @readonly
 */
const DATE_FORMATS = {
    defaultDateTime: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    },
    shortDateTime: {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    },
    shortDateFullTime: {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    },
    shortDateTimeUTC: {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC'
    },
    shortDateFullTimeUTC: {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'UTC'
    },
    shortDateTimeWoYear: {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    },
    shortDateFullTimeWoYear: {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    },
    shortDateTimeWoYearUTC: {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC'
    },
    shortDateFullTimeWoYearUTC: {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'UTC'
    },
    mediumDateTime: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
    },
    longDateTime: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
    },
    fullDateTime: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
    },
    defaultTime: {
        hour: '2-digit',
        minute: '2-digit'
    },
    defaultFullTime: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    },
    UTCTime: {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC'
    },
    UTCFullTime: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'UTC'
    },
    shortTime: {
        hour: '2-digit',
        minute: '2-digit'
    },
    mediumTime: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
    },
    longTime: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
    },
    fullTime: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
    },
    defaultDate: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    },
    shortDate: {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    },
    mediumDate: {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    },
    longDate: {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
    },
    fullDate: {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: '2-digit'
    },
    UTCDate: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
    },
    dateWoYear: {
        month: '2-digit',
        day: '2-digit'
    },
    dateWoYearUTC: {
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
    },
    shortMonth: {
        month: 'short'
    },
    longMonthYear: {
        year: 'numeric',
        month: 'long'
    }
}

export default DATE_FORMATS
